import React from "react";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { Grid, Button, Typography } from "@material-ui/core";

const CalendarNavigation = ({ classes, year, disabled, changeYear }) => {
  return (
    <Grid container className={classes.navigationContainer}>
      <Grid
        justifyContent="center"
        alignItems="center"
        item
        container
        spacing={2}
      >
        {!disabled && (
          <Grid item>
            <Button
              className={classes.selectYearBtn}
              onClick={() => changeYear(year - 1)}
            >
              <ChevronLeft fontSize="small" className={classes.leftIcon} />
              <Typography variant="caption">{year - 1}</Typography>
            </Button>
          </Grid>
        )}
        <Grid item>
          <Button
            disabled
            color="default"
            variant="outlined"
            className={classes.selectedYear}
          >
            <Typography className={classes.selectedYearTitle} variant="body2">
              {year}
            </Typography>
          </Button>
        </Grid>
        {!disabled && (
          <Grid item>
            <Button
              className={classes.selectYearBtn}
              onClick={() => changeYear(year + 1)}
            >
              <Typography variant="caption">{year + 1}</Typography>
              <ChevronRight fontSize="small" className={classes.rightIcon} />
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

const styles = theme => ({
  navigationContainer: {
    paddingBottom: theme.spacing(1),
  },
  selectedYear: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    "&.Mui-disabled": {
      color: theme.altus.calendar.contrastColor,
    },
  },
  selectYearBtn: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  selectedYearTitle: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

export default compose(withStyles(styles), React.memo)(CalendarNavigation);
